import { render } from "./picManagement.vue?vue&type=template&id=27aa1298&scoped=true"
import script from "./picManagement.vue?vue&type=script&lang=js"
export * from "./picManagement.vue?vue&type=script&lang=js"

import "./picManagement.vue?vue&type=style&index=0&id=27aa1298&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27aa1298"]])

export default __exports__